import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { PageHeading } from '../components/common/PageHeading';
import { SmartStoreMapping } from '../components/mappings/SmartStoreMapping';
import { JasperMapping } from '../components/mappings/JasperMapping';
import { usePageTitle } from '../lib/usePageTitle';

export function MappingsPage() {
    const { t } = useTranslation();
    usePageTitle(t('mappings.title'));
    return (
        <>
            <PageHeading title={t('mappings.title')} />
            <Tabs defaultActiveKey="smartstore" id="mapping-tabs" className="mb-2">
                <Tab eventKey="smartstore" title={t('mappings.smartstoreTab')}>
                    <SmartStoreMapping />
                </Tab>
                <Tab eventKey="jasper" title={t('mappings.reportingTab')}>
                    <JasperMapping />
                </Tab>
            </Tabs>
        </>
    );
}
